module.exports = __webpack_public_path__ + "img/coin-ph.4ca6a232.png";